import { supabase } from "../supabase";

export const MAX_GUESSES = 6;
export const ITEMS_PER_DAY = 5;
export const MAX_GUESS_VALUE = 300;

/**
 * How close a guess is: within 5% wins, within 25% is warm. On a cheap item a percentage is a few cents, which
 * nobody can hit, so there's a floor in dollars: a win within 25 cents, warm within 75 (an item under $5, and
 * under $3, gets that).
 */
export const WIN = { share: 0.05, least: 0.25 };
export const WARM = { share: 0.25, least: 0.75 };
export function rateGuess(guess, target) {
  const diff = Math.abs(guess - target);
  // A hair over, from the sum in floating point, still counts as on the line.
  const within = ({ share, least }) => diff <= Math.max(target * share, least) + 1e-9;
  if (within(WIN)) return "correct";
  if (within(WARM)) return guess > target ? "high" : "low";
  return guess > target ? "way high" : "way low";
}

export function generateShareText(slotStates, dailyItems, todayStr, hardModeSlots) {
  const wins = Object.values(slotStates).filter((s) => s.status === "won").length;
  const totalGuesses = Object.values(slotStates).reduce((sum, s) => sum + s.guesses.length, 0);

  let text = `Erewhondle ${todayStr}\n${wins}/${ITEMS_PER_DAY} correct | ${totalGuesses} guesses\n\n`;

  for (const d of dailyItems) {
    const state = slotStates[d.slot];
    if (!state) continue;

    const row = state.guesses.map((g) => {
      switch (g.feedback) {
        case "correct": return "\u{1F7E9}"; // green
        case "high":
        case "low": return "\u{1F7E8}"; // yellow
        case "way high":
        case "way low": return "\u{1F7E5}"; // red
        default: return "\u2B1C"; // white
      }
    }).join("");

    const isHard = hardModeSlots?.[d.slot];
    const result = state.status === "won" ? (isHard ? "\ud83d\udd25" : "\u2705") : "\u274c";
    text += `${result} ${row}\n`;
  }

  text += "\nPlay at erewhondle.com";
  return text;
}

export async function saveGameResult(userId, dateStr, slot, itemId, result, numGuesses, guessData) {
  const { error } = await supabase.from("game_stats").upsert([
    {
      user_id: userId,
      date: dateStr,
      slot,
      item_id: itemId,
      result,
      guesses: numGuesses,
      guess_data: guessData,
    },
  ], { onConflict: ["user_id", "date", "slot"] });
  if (error) {
    console.error("Error saving game result:", error);
  }
}
